// Extracts the active campaign slug from a URL pathname.
//
// The slug in the URL is the single source of truth for which campaign a
// request belongs to — deliberately NOT React state, so it cannot race against
// context initialization and always matches what the user is looking at.
//
// Must match the server's slug validation in functions/api/campaigns.js.
const SLUG_PATTERN = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;

export function campaignSlugFromPath(pathname) {
  if (typeof pathname !== 'string') return null;
  const match = pathname.match(/^\/c\/([^/?#]+)/);
  if (!match) return null;
  const slug = match[1];
  return SLUG_PATTERN.test(slug) ? slug : null;
}
